export enum OptionTarifaire {
    Base = "Base",
    HPHC = "HPHC",
    HS = "HS",
    HS_PTE_Fixe = "HS_PTE_Fixe",
}

export enum Fta {
    BTINFCU4 = "BTINFCU4",
    BTINFMU4 = "BTINFMU4",
    BTSUPCU4 = "BTSUPCU4",
    BTINFCUST = "BTINFCUST",
    BTSUPLU4 = "BTSUPLU4",
    HTACU5 = "HTACU5",
    HTALU5 = "HTALU5",
    BTINFLU = "BTINFLU",
    BTINFMUDT = "BTINFMUDT",
    HTACUPM5 = "HTACUPM5",
}

// ordre des plages horaires Heures pointes, heures pleines, heures creuses, saison haute (hiver), saison basse (été)
export const PLAGE_ORDER = ["PTE", "HPH", "HCH", "HPE", "HCE", "HPB", "HCB"]
export const PLAGE_ORDER_PRICE = [
    "abonnement",
    "prix_base",
    "prix_hp",
    "prix_hc",
    "prix_pte",
    "prix_hph",
    "prix_hch",
    "prix_hpb",
    "prix_hcb",
    "turpe",
]

/** Valeurs par défaut des coefficients de capacité selon la méthode (avec / sans coefficient) */
export const DEFAULT_COEFF_CAPACITE_VALUE = {
    /** Méthode « Par énergie avec coefficient de capacité » */
    WITH_COEFF: 0.8,
    /** Méthode « Par énergie sans coefficient de capacité » (coefficients masqués, envoyés à 1) */
    WITHOUT_COEFF: 1,
} as const

/** @deprecated Utiliser DEFAULT_COEFF_CAPACITE_VALUE.WITH_COEFF */
export const DEFAULT_COEFF_CAPACITY_VALUE =
    DEFAULT_COEFF_CAPACITE_VALUE.WITH_COEFF

export const DEFAULT_PRICER_CAPACITY_VALUE = 3.4696

/** Méthode 1 : Par puissance (prix en €/kW/an, dénivelé de puissance). */
export const CAPACITY_METHOD_PUISSANCE = "puissance" as const
/** Méthode 2 : Par énergie avec coefficient de capacité (prix en €/kW/an + coefficients par plage). */
export const CAPACITY_METHOD_ENERGIE_AVEC_COEFF = "energie" as const
/** Méthode 3 : Par énergie sans coefficient de capacité (prix en €/MWh). Utilisée pour les comparaisons et l’option du sélecteur. */
export const CAPACITY_METHOD_ENERGIE_SANS_COEFF = "energie_sans_coeff" as const
